export default function Configure($stateProvider) {
    $stateProvider.state('images', {
        parent: 'common',
        url: '/images',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('images.list', {
        url: '/list',
        template: '<images></images>',
        rights: { domain: 'images', right: 'read' },
        ncyBreadcrumb: {
            parent: 'images',
            label: '{{ "IMAGES.BREADCRUMBS.IMAGES_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_docimg',
            translate: 'IMAGES.BREADCRUMBS.IMAGES_LIST',
            order: 24
        },
        search: 'IMAGES.BREADCRUMBS.IMAGES_LIST'
    });

    $stateProvider.state('images.list.detail', {
        url: '/{id}',
        template: '<image-detail></image-detail>',
        rights: { domain: 'images', right: 'read' },
        ncyBreadcrumb: {
            parent: 'images.list',
            label: '{{ "IMAGES.BREADCRUMBS.IMAGE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('images.new', {
        url: '/new',
        template: '<image-form></image-form>',
        rights: { domain: 'images', right: 'create' },
        ncyBreadcrumb: {
            parent: 'images.list',
            label: '{{ "IMAGES.BREADCRUMBS.IMAGE_NEW" | translate}}'
        },
        search: 'IMAGES.BREADCRUMBS.IMAGE_NEW'
    });

    $stateProvider.state('images.newImage', {
        url: '/new/{idOrigine}/{domaine}',
        template: '<image-form></image-form>',
        rights: { domain: 'images', right: 'create' },
        ncyBreadcrumb: {
            parent: 'images.list',
            label: '{{ "IMAGES.BREADCRUMBS.IMAGE_NEW" | translate}}'
        }
    });

    $stateProvider.state('images.edit', {
        url: '/{id}/edit',
        template: '<image-form></image-form>',
        rights: { domain: 'images', right: 'update' },
        ncyBreadcrumb: {
            parent: 'images.list',
            label: '{{ "IMAGES.BREADCRUMBS.IMAGE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('images.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'images.new' },
        ncyBreadcrumb: {
            parent: 'images.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
